// import VueI18n from "vue-i18n";
import Vue from 'vue'
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
// import store from './store';
import en from './i18n/en.json';
import ar from './i18n/ar.json';
import {getLanguage} from "./lib/funclib";


export default new VueI18n({
    locale: getLanguage(),
    messages: {
        en: en,
        ar: ar,
    },
});
